
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { acRundeActive } from '../actions/acRundeActive';
import { acRundaSelectata } from '../actions/acRundaSelectata';
import fn from '../../Functii';

class Mid2ColRunde extends React.Component {
    // constructor() {
    //     super();
    //     this.state = {

    //         roundUnique: ''
    //     };
    // }
    componentWillMount() {
        if (this.props.index === 0) {
            var runq = this.props.rundaVal.round_unique;
            var result = this.props.rundeActive.filter(function (obj) {
                return obj === runq;
            });
            if (result.length === 0) {
                // this.props.acRundeActive([this.props.rundaVal.round_unique, this.props.appProps.conBile.type]);
                this.props.acRundeActive({ round: this.props.rundaVal.round_unique, type: 'unique' });
                this.props.acRundaSelectata({ ...this.props.rundaVal, gameType: this.props.activeLot.game_type })
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        var runq = this.props.rundaVal.round_unique;
        var result = this.props.rundeActive.filter(function (obj) {
            return obj === runq;
        });

        var runq2 = nextProps.rundaVal.round_unique;
        var result2 = nextProps.rundeActive.filter(function (obj) {
            return obj === runq2;
        });
        if ((result.length > 0) || (result2.length > 0)) {
            return true
        } else {
            return false;
        }
    }
    componentWillReceiveProps(nextProps) {

    }

    odds() {
        var odds = []
        for (var i = 0; i < this.props.activeLot.odds.length; i++) {
            if (this.props.activeLot.odds[i].slice(-3) === '000') {
                odds.push(<td key={i}>{this.props.activeLot.odds[i].slice(0, -3) + 'k'}</td>)
            } else {
                odds.push(<td key={i}>{this.props.activeLot.odds[i]}</td>)
            }
        }
        return odds;
    }
    activeConBile() {
        // this.props.acRundeActive([this.props.rundaVal.round_unique, this.props.appProps.conBile.type]);
        this.props.acRundeActive({ round: this.props.rundaVal.round_unique, type: 'unique' });
        this.props.acRundaSelectata({ ...this.props.rundaVal, gameType: this.props.activeLot.game_type });
    }
    activeClass() {
        var runq = this.props.rundaVal.round_unique;
        var result = this.props.rundeActive.filter(function (obj) {
            return obj === runq;
        });
        if (result.length > 0) {
            return 'active'
        } else {
            return ''
        }
    }
    conBile() {
        // if (this.props.appProps.conBile.type === 'clasic') {
        //     return (
        //         <td colSpan="10">
        //             <ConBile rundaVal={this.props.rundaVal} />
        //         </td>
        //     )
        // }
    }
    runda() {
        return (
            <tr onClick={this.activeConBile.bind(this)} className={this.activeClass()}>
                <td>#{this.props.rundaVal.id}</td>
                <td>{fn.timeStartTrim(this.props.rundaVal.timeStart)}</td>
                {this.odds()}
            </tr>
        )
    }
    render() {
        // console.log('ExtrageriMidItem', this.props);
        return (
            <tbody>
                {this.runda()}
                <tr className={'con-bile-tr '}>
                    {this.conBile()}
                </tr>
            </tbody>
        )
    }
}


function mapStateToProps(state) {
    return {
        activeLot: state.activeLot,
        bilete: state.bilete,
        rundeActive: state.rundeActive,
        appProps: state.appProps
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acRundeActive: acRundeActive,
        acRundaSelectata: acRundaSelectata
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(Mid2ColRunde);